import { Box } from '@opendoor/bricks-next';
import type { GetThemeValueForKey } from '@tamagui/core';
import type { MarginProps } from 'platform/bricks-next';

type Visibility = 'small' | 'large';

type DividerProps = MarginProps & {
  /**
   * Defaults to $0dot5 (1px)
   */
  thickness?: GetThemeValueForKey<'borderWidth'>;

  /**
   * What screen sizes the divider should be visible in
   * Leave empty for visibility in all screen sizes
   */
  visibility?: Visibility;

  /**
   * Defaults to 100%
   */
  width?: GetThemeValueForKey<'width'>;
};

/**
 * a simple divider - full-width horizontal rule, no default margin.
 */
export const Divider = (props: DividerProps) => {
  const { thickness, visibility, ...rest } = props;
  return (
    <Box
      display="block"
      tag="hr"
      m={0}
      $platform-web={{ borderLeft: 'none', borderRight: 'none', borderBottom: 'none' }}
      $largerThanSM={visibility === 'small' ? { display: 'none' } : undefined}
      $smallerThanMD={visibility === 'large' ? { display: 'none' } : undefined}
      borderTopWidth={thickness ?? '$0dot5x'}
      borderTopColor="$borderPrimary"
      width="100%"
      {...rest}
    />
  );
};
